import { render, staticRenderFns } from "./ActionUpdateProduct.vue?vue&type=template&id=60540e2a&"
import script from "./ActionUpdateProduct.vue?vue&type=script&lang=js&"
export * from "./ActionUpdateProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports